module.exports = __webpack_public_path__ + "img/welcome3.f3cf1ff7.jpg";